import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Page } from "../../components/page/page";
import { ChooseList } from "../../components/choose-list/choose-list";
import { setWhatDrivesYou } from "../../store/stateSlice";

const options = [
  {
    title: "achieving goals",
    icon: "🎯",
  },
  {
    title: "helping others",
    icon: "🤝",
  },
  {
    title: "learning new things",
    icon: "🎓",
  },
  {
    title: "creating something new",
    icon: "🎨",
  },
  {
    title: "other",
    icon: "✨",
  },
];

const WhatDrivesYouPage = () => {
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };
  return (
    <Page
      title="What drives you the most in life?"
      currentStep={7}
      nextPageLink="../element-of-nature"
      canGoToNextPage={selectedOptions.length === 2}
      onContinue={() => {
        dispatch(setWhatDrivesYou(selectedOptions));
      }}
    >
      <ChooseList options={options} maxSelected={2} onChange={handleChange} />
    </Page>
  );
};

export { WhatDrivesYouPage };
